import CollaboratorTicketsListPage from '../pages/collaborator-ticket/collaborator-tickets-list-page'
export default CollaboratorTicketsListPage
